import React, { useState, useEffect } from "react"
import { useRouter } from "next/router"
import _get from "lodash/get"
import { getConfig } from "@/constants/config"
import { replaceSearchUrl } from "@/utils/helper"

const TabComponent = ({ tabList = [], refData = {} }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [prevTab, setPrevTab] = useState(0)
  const [updatedTabList, setUpdatedTabList] = useState([])
  const [brandName, setBrandName] = useState({})
  const router = useRouter()

  useEffect(() => {
    getConfig().then(CONFIG => {
      setBrandName(CONFIG.general?.siteName ?? "")
    })
  }, [])

  useEffect(() => {
    const { query } = router
    const activeSortIndex = query?.activeTab
    if (activeSortIndex !== null && activeSortIndex !== undefined) {
      setActiveTab(Number(activeSortIndex))
    }
  }, [])

  useEffect(() => {
    if (showModal && _get(tabList[activeTab], "url", "")) {
      window.handleShowModal(tabList[activeTab]?.url)
    }
  }, [showModal])

  useEffect(() => {
    if (brandName !== "kohler" && tabList.length > 0) {
      const tabTempData = tabList.filter(
        tabDetails =>
          tabDetails["title"] &&
          tabDetails["title"].toLowerCase() !== "image library"
      )
      setUpdatedTabList(tabTempData)
    }
  }, [tabList, brandName])

  const changeTab = tab => {
    if (_get(tabList[tab], "url", "")) {
      if (showModal) {
        setActiveTab(prevTab)
        setShowModal(false)
        document.getElementById(`${tabList[prevTab].title}-tab`).focus()
        return
      }
      setPrevTab(activeTab)
      setShowModal(true)
    }
    setActiveTab(tab)
    replaceSearchUrl("activeTab", tab)
  }

  const handleKeyPress = e => {
    if (e.keyCode === 37 || e.keyCode === 39) {
      let tab
      if (e.keyCode === 37) {
        tab = activeTab - 1
      } else if (e.keyCode === 39) {
        tab = activeTab + 1
      }
      if (tab < 0) tab = tabList.length - 1
      if (tab >= tabList.length) tab = 0
      document.getElementById(`${tabList[tab].title}-tab`)?.focus()
    }
  }

  return (
    <React.Fragment>
      <div className="press-room__tab-header" role="tablist">
        <div className="container kf-react-container press-room__tab-buttons">
          {updatedTabList.map((tab, i) => (
            <button
              className={`press-room__tab-button gbh-data-layer ${
                activeTab === i ? "--active" : ""
              }`}
              data-gbh-data-layer={`{"eventAction":"press room:${tab.title.toLowerCase()} tab","eventName":"press room:${tab.title.toLowerCase()} tab","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"${tab.title.toLowerCase()}","internalLinkPosition":"press room","internalLinkType":"press room:navigation","internalLinkZoneName":"press room:hero banner","internalLinkURL":"n/a","clickInternalLinks":"true"}`}
              role="tab"
              tabIndex={tabList[activeTab].title === tab.title ? 0 : -1}
              aria-controls={`${tab.title}-panel`}
              id={`${tab.title}-tab`}
              key={i}
              onClick={() => changeTab(i)}
              onFocus={() => changeTab(i)}
              onKeyDown={e => handleKeyPress(e)}
              ref={activeTab === i ? refData : null}
            >
              {`${tab.title}`}
            </button>
          ))}
        </div>
      </div>
      {_get(tabList[activeTab], "content", "") && (
        <div
          className="press-room__tab-content"
          id={`${tabList[activeTab].title}-panel`}
          aria-labelledby={`${tabList[activeTab].title}-tab`}
        >
          {_get(tabList[activeTab], "content", "")}
        </div>
      )}
    </React.Fragment>
  )
}

export default TabComponent
